module.exports = __webpack_public_path__ + "img/Stab_S5.990507c0.svg";